// extracted by mini-css-extract-plugin
export default {"error_page_container":"ErrorPage_error_page_container__P-ZMv","icon":"ErrorPage_icon__z2OEb","text":"ErrorPage_text__dnsby"};